import React, { ReactElement } from "react";

const Sample = (): ReactElement => {
  return (
    <div className="py-4">
      {/* <p>Sample content goes here</p>
      <div className="mt-4 space-x-2">
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          onClick={() => navigate("/fff")}
        >
          Test Navigation
        </button>
        <button
          className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
          onClick={() => navigate(RoutePaths.logout)}
        >
          Logout
        </button>
      </div> */}
    </div>
  );
};

export default Sample;
